import store from '@/store';
import { permissions } from '@/store/permissions';

export const mixinRoles = {
  methods: {
    hasPermission(path){
      //si no esta definido permite por defecto
      const rolesPermitted = this.deepFind(permissions, path);
      if(rolesPermitted != undefined){
        return rolesPermitted.includes(store.state.login.role);
      } else {
        return true
      }
    },
    deepFind(obj, path) {
      let paths = path.split('.')
        , current = obj
        , i;

      for (i = 0; i < paths.length; ++i) {
        if (current[paths[i]] == undefined) {
          return undefined;
        } else {
          current = current[paths[i]];
        }
      }
      return current;
    },
  }
};
